var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-grey"},[_c('navbar'),_vm._v(" "),_c('div',{staticStyle:{"min-height":"50vh"}},[_c('detail')],1),_vm._v(" "),_c('vue-element-loading',{attrs:{"active":_vm.loadingdetail,"is-full-screen":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aab1d33","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/detail.vue
// module id = null
// module chunks = 